export class User {
  public username: string;
  public email?: string;
  public token: string;
  public status: number;

  constructor(username: string, token: string);
  constructor(username: string, token: string, email: string);

  constructor(...userFields: any[]) {
    this.username = userFields[0];
    this.token = userFields[1];
    this.status = 0;
    if (userFields.length == 3) {
      this.email = userFields[2];
    }
  }
}
